import React from 'react';

const VARIANT_CLASS = {
  flat: 'ads-card--flat',
  elevated: 'ads-card--elevated',
  interactive: 'ads-card--interactive',
};

/**
 * ADS Card — panels, metrics, chart containers (Phase 5).
 */
const AdsCard = ({
  children,
  variant = 'elevated',
  className = '',
  as: Tag = 'div',
  ...props
}) => {
  const classes = ['ads-card', VARIANT_CLASS[variant] || VARIANT_CLASS.elevated, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
};

export const AdsCardTitle = ({ children, className = '' }) => (
  <h3 className={['ads-card__title', 'ads-type-card-title', className].filter(Boolean).join(' ')}>
    {children}
  </h3>
);

export default AdsCard;
